import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `LineaGenetica/imprimirLineaGenetica`, method: 'POST', body: list, token: token})
}
